import styled from '@emotion/styled';
import { Button } from 'antd';
import { isFunction } from 'lodash-es';
import { memo, ReactNode, useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { LocalMessage } from 'hooks/business/conversation';
import { isTiKTok } from 'lib/utils/isTikTok';
import { useMemoizedFn } from 'ahooks';

const Line = styled.div`
  padding: 7px 14px;
  word-wrap: break-word;
  background-color: #fff7f7;
  color: #515359;
  padding-bottom: 8px;
  margin-top: 8px;
`;

export interface ErrorReasonProps {
  msg?: string;
  message: LocalMessage;
  className?: string;
  reSendImage?: Conversation.FailContent['reSendImage'];
  extra?: ReactNode;
}

const ErrorReason = (props: ErrorReasonProps) => {
  const { msg, message, className, reSendImage, extra } = props;
  const { msgId } = message;
  const { t } = useTranslate();

  const formatTikTokFailCause = useMemoizedFn((failCause: Conversation.FailContent) => {
    const { code } = failCause;
    console.log('code', code);
    if (code === 'TIMEOUT') {
      return t('发送视频失败，请稍后重试');
    } else {
      try {
        const rpaError = JSON.parse(code) as { code: number; cause?: string };
        const rpaErrorCode = rpaError?.code;
        const rpaErrorCause = rpaError?.cause;
        if (rpaErrorCode === 1) {
          return t('发送视频失败，请检查插件是否正常运行');
        }
        if (rpaErrorCode === 2) {
          return t('发送视频失败，请检查插件网络是否可用');
        }
        if (rpaErrorCode === 3) {
          return t('发送视频失败，请检查插件网络是否可用');
        }
        if (rpaErrorCode === 4) {
          return t('发送视频失败，请检查插件网络是否可用');
        }
        if (rpaErrorCode === 5) {
          return t('发送视频失败，请稍后重试');
        }
        if (rpaErrorCode === 6) {
          return t('发送视频失败，请在卖家中心确认买家是否存在');
        }
        if (rpaErrorCode === 7) {
          return t('发送视频失败，请检查插件网络是否可用');
        }
        if (rpaErrorCode === 8) {
          const r1 = 'is currently helping this user';
          if (rpaErrorCause?.includes(r1)) {
            const [customerService] = rpaErrorCause.split(r1);
            if (customerService.trim()) {
              return t('该聊天在卖家中心由x提供服务', {
                x: customerService.trim(),
              });
            }
          }
          return t('发送视频失败，请在卖家中心检查买家会话是否正常');
        }
        if (rpaErrorCode === 9) {
          return t('发送视频失败，请在卖家中心检查买家会话是否正常');
        }
        if (rpaErrorCode === 10) {
          return t('卖家中心搜索买家失败，请稍后再试');
        }
        console.log('rpaError', rpaError);
      } catch (error) {
        console.log('error', error);
      }
    }
    return null;
  });

  const msgText = useMemo(() => {
    const { channel, failCause } = message;
    if (isTiKTok(channel) && failCause) {
      const result = formatTikTokFailCause(failCause);
      if (result) {
        return result;
      }
    }

    return msg;
  }, [formatTikTokFailCause, message, msg]);

  if (!msgText) {
    return null;
  }

  return (
    <div>
      <Line style={{ display: 'inline-block' }} className={className}>
        {msgText}
        {isFunction(reSendImage) ? (
          <Button type="link" onClick={() => reSendImage(msgId)}>
            {t('ViewsChat.点击重试')}
          </Button>
        ) : null}
      </Line>
      {extra}
    </div>
  );
};
export default memo(ErrorReason);
